import React from 'react'

import './telesales-loading.scss'

export const TelesalesLoading = () => {
  return <div className="telesales-loading" />
}
